import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { App } from "antd";

import { AlertContextProvider } from "@contexts/Alerts";
import { AuthContextProvider } from "@contexts/Auth";
import { ClientSettingsProvider } from "@contexts/ClientSettings";
import { CorbanContextProvider } from "@contexts/Corban";
import { FeatureFlagsProvider } from "@contexts/FeatureFlagsProvider";
import { MessageContextProvider } from "@contexts/Message";
import { MonitoringProvider } from "@contexts/Monitoring";
import { NotificationContextProvider } from "@contexts/Notification";
import { PermissionsContextProvider } from "@contexts/Permissions";
import { StyleProvider } from "@styles/StyleProvider";

import AppConfig from "../AppConfig";

export const ProvidersAndConfigs = () => {
  return (
    <HelmetProvider>
      <FeatureFlagsProvider>
        <ClientSettingsProvider>
          <MonitoringProvider>
            <StyleProvider>
              <App component={false}>
                <MessageContextProvider>
                  <NotificationContextProvider>
                    <AlertContextProvider>
                      <AuthContextProvider>
                        <CorbanContextProvider>
                          <PermissionsContextProvider>
                            <AppConfig>
                              <Outlet />
                            </AppConfig>
                          </PermissionsContextProvider>
                        </CorbanContextProvider>
                      </AuthContextProvider>
                    </AlertContextProvider>
                  </NotificationContextProvider>
                </MessageContextProvider>
              </App>
            </StyleProvider>
          </MonitoringProvider>
        </ClientSettingsProvider>
      </FeatureFlagsProvider>
    </HelmetProvider>
  );
};
